export function getCookie(cookieName) {
  var strCookie = document.cookie;
  var arrCookie = strCookie.split("; ");
  for (var i = 0; i < arrCookie.length; i++) {
      var arr = arrCookie[i].split("=");
      if (cookieName == arr[0]) {
        // console.log(arr[1])
        return arr[1];
      }
  }
  return;
}

export function delCookie(c_name) {
  setCookie(c_name, "", -1)
}
//设置cookie
export function setCookie(cname, cvalue) {
  var exdays = 1;
  // document.cookie = 'QRY' + "=" + window.location.href + "; ";
  var d = new Date();
  //(半小时)
  // d.setTime(d.getTime() + (exdays  * 30 * 60 * 1000));
  //一天
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  var expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + "; " + expires;
}

